module.exports = __webpack_public_path__ + "static/media/imgo4.8e2081db.jpg";